import { Gender } from '@lean-body/src/view/constants';
import { AVATAR_DEFAULT_SRC } from '@lean-body/components/atoms/avatar_uploader';
export class UserProfile {
    constructor(profile, config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalCal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalWatchDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalSteps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "watchedCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "birthday", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "height", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "weight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prefecture", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userNameMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "profilePictureSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isAutoPlayNextVideo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLeagueParticipating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isStreakCompletionHidden", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isWeightHidden", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showGoalAchievedDialog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exerciseFrequency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "activityLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isGoalsSet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "worries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "interests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sessionDurationType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sessionDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exerciseRoutineType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exerciseRoutine", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "exerciseRestrictions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "availableTools", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "targetBodyPartTags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "DEFAULT_USER_NAME", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'No Name'
        });
        Object.defineProperty(this, "MAX_USER_NAME_LENGTH", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 15
        });
        Object.defineProperty(this, "UserNameMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                Success: '',
                ExceedLengthLimitError: `${this.MAX_USER_NAME_LENGTH}文字以内で入力してください。`,
                UpdateError: '更新に失敗しました',
            }
        });
        this.userId = profile.userId;
        this.totalCal = profile.totalCal;
        this.totalWatchDuration = profile.totalWatchDuration;
        this.totalSteps = profile.totalSteps;
        this.watchedCount = profile.watchedCount;
        this.userName = profile.userName;
        this.gender = profile.gender;
        this.birthday = profile.birthday ? profile.birthday.substring(0, 10) : '';
        this.height = profile.height;
        this.weight = profile.weight;
        this.prefecture = profile.prefecture;
        this.profilePictureSrc = profile.profilePictureSrc;
        this.isAutoPlayNextVideo = profile.isAutoPlayNextVideo;
        this.isLeagueParticipating = profile.isLeagueParticipating;
        this.isStreakCompletionHidden = profile.isStreakCompletionHidden;
        this.isWeightHidden = profile.isWeightHidden;
        this.exerciseFrequency = profile.exerciseFrequency;
        this.activityLevel = profile.activityLevel;
        this.worries = profile.worries;
        this.interests = profile.interests;
        this.sessionDurationType = (_c = (_a = profile.sessionDurationType) !== null && _a !== void 0 ? _a : (_b = profile.sessionDuration) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : '';
        this.sessionDuration = profile.sessionDuration;
        this.exerciseRoutineType = (_f = (_d = profile.exerciseRoutineType) !== null && _d !== void 0 ? _d : (_e = profile.exerciseRoutine) === null || _e === void 0 ? void 0 : _e.type) !== null && _f !== void 0 ? _f : '';
        this.exerciseRoutine = profile.exerciseRoutine;
        this.exerciseRestrictions = (_g = profile.exerciseRestrictions) !== null && _g !== void 0 ? _g : [];
        this.availableTools = (_h = profile.availableTools) !== null && _h !== void 0 ? _h : [];
        this.targetBodyPartTags = (_j = profile.targetBodyPartTags) !== null && _j !== void 0 ? _j : [];
        this.showGoalAchievedDialog = profile.showGoalAchievedDialog;
        this.isGoalsSet = profile.isGoalsSet;
        this.config = config;
    }
    get initialName() {
        return this.userName ? this.userName : this.DEFAULT_USER_NAME;
    }
    get genderName() {
        var _a;
        const key = Object.keys(Gender).find((key) => {
            return this.gender === Gender[key].value;
        });
        return (_a = Gender[key]) === null || _a === void 0 ? void 0 : _a.name;
    }
    get worriesNames() {
        return this.worries.map((worry) => worry.content);
    }
    get worriesIdsToString() {
        if (!this.worries.length) {
            return [];
        }
        return this.worries.map((worry) => {
            return `${worry['id']}`;
        });
    }
    get interestsNames() {
        return this.interests.map((interest) => interest.content);
    }
    get interestsIdsToString() {
        if (!this.interests.length) {
            return [];
        }
        return this.interests.map((interest) => {
            return `${interest['id']}`;
        });
    }
    get targetBodyPartTagsNames() {
        return this.targetBodyPartTags.map((t) => t.name);
    }
    get targetBodyPartTagIdsToString() {
        return this.targetBodyPartTags.map((t) => `${t.id}`);
    }
    get exerciseRestrictionsNames() {
        return this.exerciseRestrictions.map((r) => r.content);
    }
    get exerciseRestrictionIdsToString() {
        return this.exerciseRestrictions.map((r) => `${r.id}`);
    }
    get availableToolsNames() {
        return this.availableTools.map((t) => t.content);
    }
    get availableToolIdsToString() {
        return this.availableTools.map((t) => `${t.id}`);
    }
    get pictureSrc() {
        return this.profilePictureSrc ? this.config.cdnUserBaseURL + '/' + this.profilePictureSrc : AVATAR_DEFAULT_SRC;
    }
    validateUserName(userName) {
        if (userName.length > this.MAX_USER_NAME_LENGTH) {
            this.userNameMessage = this.UserNameMessages.ExceedLengthLimitError;
            return false;
        }
        this.userNameMessage = this.UserNameMessages.Success;
        if (userName !== this.DEFAULT_USER_NAME) {
            return true;
        }
        if (userName.length > 0) {
            return true;
        }
    }
    validateHeight(height) {
        const minHeight = 0;
        const maxHeight = 300;
        return minHeight <= height && height <= maxHeight;
    }
}
